<router-outlet *ngIf="isUserSetAdult$(); else agreement"/>

<ng-template #agreement>
  <sens-agreement/>
</ng-template>

<sens-cookie-consent/>
<sens-icons/>
